module.exports = __webpack_public_path__ + "static/media/018.82f5979e.jpg";